import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StateContractService {
  private apiUrl = `${environment.apiUrl}/statecontracts`;

  constructor(private http: HttpClient) {}

  comboStateContract(): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl + '/combo');
  }
}
